import React from 'react';
import mainCv from '../Images/mainCv.png';
import Button from '@mui/material/Button';
import '../style/main.css';
import Typed from "react-typed";

function Main({fun}) {
  
  return (
   <>
   <div className='main'>

   <div className='maindiv'>
        <div style={{flex:2.5}}>
        <img src={mainCv} alt='' className='mainimg'/>
        </div>
        <div style={{flex:3}} className='mddd2'>
        <h1 className='animatedtype'>

            <Typed
            strings={["Create Your Resume ❤️ ", "Create Awesome Resume ⚡", "Get A Job  ⭐️ "]}
            typeSpeed={80}
            backSpeed={80}
            loop
          />
            </h1>
            <Button id='mainButt' variant="contained" onClick={fun}>Create</Button>
        </div>
   </div>
   </div>
   </>
  )
}

export default Main